import _definePage_default_0 from '/home/rtldev/service/frontend-emoney/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/rtldev/service/frontend-emoney/src/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from '/home/rtldev/service/frontend-emoney/src/pages/admin/api-key/index.vue?definePage&vue'
import _definePage_default_4 from '/home/rtldev/service/frontend-emoney/src/pages/admin/api-key/update/[...id].vue?definePage&vue'
import _definePage_default_5 from '/home/rtldev/service/frontend-emoney/src/pages/admin/card/index.vue?definePage&vue'
import _definePage_default_6 from '/home/rtldev/service/frontend-emoney/src/pages/admin/card/create.vue?definePage&vue'
import _definePage_default_7 from '/home/rtldev/service/frontend-emoney/src/pages/admin/card/update/[...id].vue?definePage&vue'
import _definePage_default_8 from '/home/rtldev/service/frontend-emoney/src/pages/admin/card/view/[...id].vue?definePage&vue'
import _definePage_default_9 from '/home/rtldev/service/frontend-emoney/src/pages/admin/card-holders/index.vue?definePage&vue'
import _definePage_default_10 from '/home/rtldev/service/frontend-emoney/src/pages/admin/card-holders/create.vue?definePage&vue'
import _definePage_default_11 from '/home/rtldev/service/frontend-emoney/src/pages/admin/card-holders/update/[...id].vue?definePage&vue'
import _definePage_default_12 from '/home/rtldev/service/frontend-emoney/src/pages/admin/card-holders/view/[...id].vue?definePage&vue'
import _definePage_default_13 from '/home/rtldev/service/frontend-emoney/src/pages/admin/center-balance/index.vue?definePage&vue'
import _definePage_default_14 from '/home/rtldev/service/frontend-emoney/src/pages/admin/clearing-report/index.vue?definePage&vue'
import _definePage_default_15 from '/home/rtldev/service/frontend-emoney/src/pages/admin/dashboard/index.vue?definePage&vue'
import _definePage_default_16 from '/home/rtldev/service/frontend-emoney/src/pages/admin/dispute-handling/index.vue?definePage&vue'
import _definePage_default_17 from '/home/rtldev/service/frontend-emoney/src/pages/admin/dispute-handling/create.vue?definePage&vue'
import _definePage_default_18 from '/home/rtldev/service/frontend-emoney/src/pages/admin/fraud-transaction/index.vue?definePage&vue'
import _definePage_default_19 from '/home/rtldev/service/frontend-emoney/src/pages/admin/import-by-mall/index.vue?definePage&vue'
import _definePage_default_20 from '/home/rtldev/service/frontend-emoney/src/pages/admin/location/index.vue?definePage&vue'
import _definePage_default_21 from '/home/rtldev/service/frontend-emoney/src/pages/admin/location/create.vue?definePage&vue'
import _definePage_default_22 from '/home/rtldev/service/frontend-emoney/src/pages/admin/location/update/[...id].vue?definePage&vue'
import _definePage_default_23 from '/home/rtldev/service/frontend-emoney/src/pages/admin/location/view/[...id].vue?definePage&vue'
import _definePage_default_24 from '/home/rtldev/service/frontend-emoney/src/pages/admin/login-user/index.vue?definePage&vue'
import _definePage_default_25 from '/home/rtldev/service/frontend-emoney/src/pages/admin/login-user/create.vue?definePage&vue'
import _definePage_default_26 from '/home/rtldev/service/frontend-emoney/src/pages/admin/login-user/update/[...id].vue?definePage&vue'
import _definePage_default_27 from '/home/rtldev/service/frontend-emoney/src/pages/admin/login-user/view/[...id].vue?definePage&vue'
import _definePage_default_28 from '/home/rtldev/service/frontend-emoney/src/pages/admin/mall/index.vue?definePage&vue'
import _definePage_default_29 from '/home/rtldev/service/frontend-emoney/src/pages/admin/mall/create.vue?definePage&vue'
import _definePage_default_30 from '/home/rtldev/service/frontend-emoney/src/pages/admin/mall/update/[...id].vue?definePage&vue'
import _definePage_default_31 from '/home/rtldev/service/frontend-emoney/src/pages/admin/merchant/index.vue?definePage&vue'
import _definePage_default_32 from '/home/rtldev/service/frontend-emoney/src/pages/admin/merchant/create.vue?definePage&vue'
import _definePage_default_33 from '/home/rtldev/service/frontend-emoney/src/pages/admin/merchant/update/[...id].vue?definePage&vue'
import _definePage_default_34 from '/home/rtldev/service/frontend-emoney/src/pages/admin/merchant/view/[...id].vue?definePage&vue'
import _definePage_default_35 from '/home/rtldev/service/frontend-emoney/src/pages/admin/parameter-setting-system/index.vue?definePage&vue'
import _definePage_default_36 from '/home/rtldev/service/frontend-emoney/src/pages/admin/parameter-setting-system/update/[...id].vue?definePage&vue'
import _definePage_default_37 from '/home/rtldev/service/frontend-emoney/src/pages/admin/parameter-setting-system/view/[...id].vue?definePage&vue'
import _definePage_default_38 from '/home/rtldev/service/frontend-emoney/src/pages/admin/role/index.vue?definePage&vue'
import _definePage_default_39 from '/home/rtldev/service/frontend-emoney/src/pages/admin/role/create.vue?definePage&vue'
import _definePage_default_40 from '/home/rtldev/service/frontend-emoney/src/pages/admin/role/update/[...id].vue?definePage&vue'
import _definePage_default_41 from '/home/rtldev/service/frontend-emoney/src/pages/admin/role/view/[...id].vue?definePage&vue'
import _definePage_default_42 from '/home/rtldev/service/frontend-emoney/src/pages/admin/settlement-report/index.vue?definePage&vue'
import _definePage_default_43 from '/home/rtldev/service/frontend-emoney/src/pages/admin/settlement-report/view.vue?definePage&vue'
import _definePage_default_44 from '/home/rtldev/service/frontend-emoney/src/pages/admin/shop/index.vue?definePage&vue'
import _definePage_default_45 from '/home/rtldev/service/frontend-emoney/src/pages/admin/shop/create.vue?definePage&vue'
import _definePage_default_46 from '/home/rtldev/service/frontend-emoney/src/pages/admin/shop/update/[...id].vue?definePage&vue'
import _definePage_default_47 from '/home/rtldev/service/frontend-emoney/src/pages/admin/shop/view/[...id].vue?definePage&vue'
import _definePage_default_48 from '/home/rtldev/service/frontend-emoney/src/pages/admin/terminal/index.vue?definePage&vue'
import _definePage_default_49 from '/home/rtldev/service/frontend-emoney/src/pages/admin/terminal/create.vue?definePage&vue'
import _definePage_default_50 from '/home/rtldev/service/frontend-emoney/src/pages/admin/terminal/update/[...id].vue?definePage&vue'
import _definePage_default_51 from '/home/rtldev/service/frontend-emoney/src/pages/admin/transaction-history/index.vue?definePage&vue'
import _definePage_default_52 from '/home/rtldev/service/frontend-emoney/src/pages/forgot-password.vue?definePage&vue'
import _definePage_default_53 from '/home/rtldev/service/frontend-emoney/src/pages/login.vue?definePage&vue'
import _definePage_default_54 from '/home/rtldev/service/frontend-emoney/src/pages/not-authorized.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/home/rtldev/service/frontend-emoney/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/rtldev/service/frontend-emoney/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
      {
        path: 'api-key',
        /* internal name: 'admin-api-key' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-api-key',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/api-key/index.vue'),
            /* no children */
          },
  _definePage_default_3
  ),
          {
            path: 'update',
            /* internal name: 'admin-api-key-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-api-key-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/api-key/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_4
  )
            ],
          }
        ],
      },
      {
        path: 'card',
        /* internal name: 'admin-card' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-card',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/card/index.vue'),
            /* no children */
          },
  _definePage_default_5
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-card-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/card/create.vue'),
            /* no children */
          },
  _definePage_default_6
  ),
          {
            path: 'update',
            /* internal name: 'admin-card-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-card-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/card/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_7
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'admin-card-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-card-view$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/card/view/[...id].vue'),
                /* no children */
              },
  _definePage_default_8
  )
            ],
          }
        ],
      },
      {
        path: 'card-holders',
        /* internal name: 'admin-card-holders' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-card-holders',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/card-holders/index.vue'),
            /* no children */
          },
  _definePage_default_9
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-card-holders-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/card-holders/create.vue'),
            /* no children */
          },
  _definePage_default_10
  ),
          {
            path: 'update',
            /* internal name: 'admin-card-holders-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-card-holders-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/card-holders/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_11
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'admin-card-holders-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-card-holders-view$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/card-holders/view/[...id].vue'),
                /* no children */
              },
  _definePage_default_12
  )
            ],
          }
        ],
      },
      {
        path: 'center-balance',
        /* internal name: 'admin-center-balance' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-center-balance',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/center-balance/index.vue'),
            /* no children */
          },
  _definePage_default_13
  )
        ],
      },
      {
        path: 'clearing-report',
        /* internal name: 'admin-clearing-report' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-clearing-report',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/clearing-report/index.vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      },
      {
        path: 'dashboard',
        /* internal name: 'admin-dashboard' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-dashboard',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/dashboard/index.vue'),
            /* no children */
          },
  _definePage_default_15
  )
        ],
      },
      {
        path: 'dispute-handling',
        /* internal name: 'admin-dispute-handling' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-dispute-handling',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/dispute-handling/index.vue'),
            /* no children */
          },
  _definePage_default_16
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-dispute-handling-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/dispute-handling/create.vue'),
            /* no children */
          },
  _definePage_default_17
  )
        ],
      },
      {
        path: 'fraud-transaction',
        /* internal name: 'admin-fraud-transaction' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-fraud-transaction',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/fraud-transaction/index.vue'),
            /* no children */
          },
  _definePage_default_18
  )
        ],
      },
      {
        path: 'import-by-mall',
        /* internal name: 'admin-import-by-mall' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-import-by-mall',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/import-by-mall/index.vue'),
            /* no children */
          },
  _definePage_default_19
  )
        ],
      },
      {
        path: 'location',
        /* internal name: 'admin-location' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-location',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/location/index.vue'),
            /* no children */
          },
  _definePage_default_20
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-location-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/location/create.vue'),
            /* no children */
          },
  _definePage_default_21
  ),
          {
            path: 'update',
            /* internal name: 'admin-location-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-location-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/location/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_22
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'admin-location-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-location-view$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/location/view/[...id].vue'),
                /* no children */
              },
  _definePage_default_23
  )
            ],
          }
        ],
      },
      {
        path: 'login-user',
        /* internal name: 'admin-login-user' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-login-user',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/login-user/index.vue'),
            /* no children */
          },
  _definePage_default_24
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-login-user-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/login-user/create.vue'),
            /* no children */
          },
  _definePage_default_25
  ),
          {
            path: 'update',
            /* internal name: 'admin-login-user-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-login-user-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/login-user/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_26
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'admin-login-user-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-login-user-view$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/login-user/view/[...id].vue'),
                /* no children */
              },
  _definePage_default_27
  )
            ],
          }
        ],
      },
      {
        path: 'mall',
        /* internal name: 'admin-mall' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-mall',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/mall/index.vue'),
            /* no children */
          },
  _definePage_default_28
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-mall-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/mall/create.vue'),
            /* no children */
          },
  _definePage_default_29
  ),
          {
            path: 'update',
            /* internal name: 'admin-mall-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-mall-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/mall/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_30
  )
            ],
          }
        ],
      },
      {
        path: 'merchant',
        /* internal name: 'admin-merchant' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-merchant',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/merchant/index.vue'),
            /* no children */
          },
  _definePage_default_31
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-merchant-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/merchant/create.vue'),
            /* no children */
          },
  _definePage_default_32
  ),
          {
            path: 'update',
            /* internal name: 'admin-merchant-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-merchant-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/merchant/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_33
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'admin-merchant-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-merchant-view$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/merchant/view/[...id].vue'),
                /* no children */
              },
  _definePage_default_34
  )
            ],
          }
        ],
      },
      {
        path: 'parameter-setting-system',
        /* internal name: 'admin-parameter-setting-system' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-parameter-setting-system',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/parameter-setting-system/index.vue'),
            /* no children */
          },
  _definePage_default_35
  ),
          {
            path: 'update',
            /* internal name: 'admin-parameter-setting-system-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-parameter-setting-system-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/parameter-setting-system/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_36
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'admin-parameter-setting-system-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-parameter-setting-system-view$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/parameter-setting-system/view/[...id].vue'),
                /* no children */
              },
  _definePage_default_37
  )
            ],
          }
        ],
      },
      {
        path: 'role',
        /* internal name: 'admin-role' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-role',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/role/index.vue'),
            /* no children */
          },
  _definePage_default_38
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-role-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/role/create.vue'),
            /* no children */
          },
  _definePage_default_39
  ),
          {
            path: 'update',
            /* internal name: 'admin-role-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-role-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/role/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_40
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'admin-role-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-role-view$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/role/view/[...id].vue'),
                /* no children */
              },
  _definePage_default_41
  )
            ],
          }
        ],
      },
      {
        path: 'settlement-report',
        /* internal name: 'admin-settlement-report' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-settlement-report',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/settlement-report/index.vue'),
            /* no children */
          },
  _definePage_default_42
  ),
  _mergeRouteRecord(
          {
            path: 'view',
            name: 'admin-settlement-report-view',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/settlement-report/view.vue'),
            /* no children */
          },
  _definePage_default_43
  )
        ],
      },
      {
        path: 'shop',
        /* internal name: 'admin-shop' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-shop',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/shop/index.vue'),
            /* no children */
          },
  _definePage_default_44
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-shop-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/shop/create.vue'),
            /* no children */
          },
  _definePage_default_45
  ),
          {
            path: 'update',
            /* internal name: 'admin-shop-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-shop-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/shop/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_46
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'admin-shop-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-shop-view$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/shop/view/[...id].vue'),
                /* no children */
              },
  _definePage_default_47
  )
            ],
          }
        ],
      },
      {
        path: 'terminal',
        /* internal name: 'admin-terminal' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-terminal',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/terminal/index.vue'),
            /* no children */
          },
  _definePage_default_48
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'admin-terminal-create',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/terminal/create.vue'),
            /* no children */
          },
  _definePage_default_49
  ),
          {
            path: 'update',
            /* internal name: 'admin-terminal-update' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id(.*)',
                name: 'admin-terminal-update$id',
                component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/terminal/update/[...id].vue'),
                /* no children */
              },
  _definePage_default_50
  )
            ],
          }
        ],
      },
      {
        path: 'transaction-history',
        /* internal name: 'admin-transaction-history' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-transaction-history',
            component: () => import('/home/rtldev/service/frontend-emoney/src/pages/admin/transaction-history/index.vue'),
            /* no children */
          },
  _definePage_default_51
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/home/rtldev/service/frontend-emoney/src/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_52
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/rtldev/service/frontend-emoney/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_53
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/rtldev/service/frontend-emoney/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_54
  )
]
